"use client";

import { c as _c } from "react/compiler-runtime";
import React, { memo } from "react";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import ImageComponent from "@/components/ui/image";
import HeroDiwaliBg from "@/assets/images/v2/hero-diwali-mobile-bg.webp";
import { THE_DIWALI_FAVOURITES_COLLECTION_ID, MEANINGFUL_DIWALI_COLLECTION_ID } from "@/constants/product";
export const DiwaliMobileHero = memo(() => {
  const $ = _c(9);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ImageComponent className="absolute inset-0 w-full h-full object-cover object-center" alt="Handcrafted blown-glass puja diyas glowing with warm flickering flames" src={HeroDiwaliBg} fill={true} sizes="(max-width: 1024px) 100vw, 1px" fetchPriority="high" loading="eager" />;
    t1 = <div className="absolute inset-0 bg-gradient-to-t from-[#140b05] via-[#1b1510]/75 via-50% to-black/25" />;
    t2 = <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom,rgba(255,179,128,0.18)_0%,transparent_70%)] pointer-events-none" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-black/50 border border-[#ffb380]/40 text-[#ffdcc7] font-medium text-[10px] tracking-[0.2em] uppercase mb-4 shadow-lg -translate-y-6"><span className="w-1.5 h-1.5 rounded-full bg-[#fed65b] animate-pulse" /><span>Diwali Exclusive • Limited Edition</span></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col items-center">{t3}<h2 className="text-2xl text-[#FCFAF5] font-serif tracking-wide leading-[1.3] drop-shadow-md">This Diwali,{t4} <span className="">Do Something Meaningful.</span></h2></div>;
    t6 = <p className="text-sm text-[#e4e2dd]/90 max-w-xl leading-relaxed font-light">Celebrate Diwali with meaningful gifts that honor tradition, support master artisans and bring joy to the people who matter most.</p>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Link href={`/listing/the-diwali-favourites?id=${THE_DIWALI_FAVOURITES_COLLECTION_ID}`} prefetch={true} className="w-full"><Button className="w-full bg-[#037A6A] hover:bg-[#005f52] text-white text-xs tracking-[0.12em] uppercase px-7 py-5 rounded transition-all duration-300 shadow-[0_4px_20px_rgba(3,122,106,0.35)] hover:shadow-[0_6px_24px_rgba(3,122,106,0.5)] active:scale-95 flex items-center justify-center gap-2 h-auto font-bold"><span>explore Diwali favorites</span><ArrowRight className="size-4" strokeWidth={2.5} /></Button></Link>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="relative w-full h-[600px] overflow-hidden flex flex-col">{t0}{t1}{t2}<div className="relative z-10 w-full h-full max-w-3xl mx-auto px-6 pb-14 pt-40 text-center flex flex-col justify-between items-center">{t5}{t6}<div className="flex flex-col items-center justify-center gap-3.5 w-full">{t7}<Link href={`/listing/meaningful-diwali?category_id=${MEANINGFUL_DIWALI_COLLECTION_ID}`} prefetch={true} className="w-full"><Button variant="outline" className="w-full inline-flex items-center justify-center text-xs tracking-[0.12em] uppercase px-6 py-5 rounded border border-[#ffb380]/60 hover:border-[#ffdcc7] text-[#ffdcc7] hover:text-white bg-black/25 transition-all duration-300 hover:bg-black/40 h-auto font-bold">explore all festive collections</Button></Link></div></div></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
});
DiwaliMobileHero.displayName = "DiwaliMobileHero";